import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { scrollToImageStateSchema } from '../../schemas';
import { useIsFullscreenImageOpen } from '../useIsFullscreenImageOpen';

/**
 * Get the `aiGeneratedImageId` that should be scroll to from location state (if
 * it exists and we're not currently in the fullscreen image modal)
 *
 * @returns tuple containing the `aiGeneratedImageId` to scroll to and a
 * function to clear the location state after scrolling
 */
export const useScrollToImage = () => {
  const { state, pathname } = useLocation();
  const history = useHistory();

  const { aiGeneratedImageId: scrollToId } =
    scrollToImageStateSchema.isValidSync(state)
      ? state
      : { aiGeneratedImageId: null };

  const clear = useCallback(() => {
    history.replace(pathname, null);
  }, [history, pathname]);

  // Don't return an image to scroll to if we're on a fullscreen route as the
  // fullscreen image view manages the list scroll position as well
  const isFullscreen = useIsFullscreenImageOpen();

  return [isFullscreen ? null : scrollToId, clear] as const;
};
